export default (
    state = {
      isFetching: true,
      data: {
        isClosedForMaintenance: false,
        maintenancePeriod: {
            title: '',
            outageMessage: '',
            dateRange: {},
            outageAlertTitle: '',
            outageAlertMessage: ''
        }
      }
    },
    action
  ) => {
    switch (action.type) {
      case 'FETCH_MAINTENANCE_PERIODS':
        return {
          ...state,
          isFetching: true
        }
      case 'RECEIVE_MAINTENANCE_PERIODS':
        return {
          ...state, 
          isFetching: false,
          data: action.data ? action.data : state.data 
        }
      default:
        return state
    }
  }
  